<template>
  <el-dialog
    title="全局配置"
    :visible="visible"
    :close-on-click-modal="false"
    @close="handleClose"
    @open="handleOpen"
    class="mini-dialog"
  >
    <el-form :model="formData" label-width="160px" :rules="formRules" ref="formRef">
      <el-form-item label="左侧面板最大共存数" prop="leftMaxNum">
        <el-input-number
          v-model="formData.leftMaxNum"
          :min="1"
          :max="3"
          controls-position="right"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="右侧面板最大共存数" prop="rightMaxNum">
        <el-input-number
          v-model="formData.rightMaxNum"
          :min="1"
          :max="3"
          controls-position="right"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="默认开启板块" prop="defaultSection">
        <el-select v-model="formData.defaultSection" value-key="value" filterable>
          <el-option
            v-for="item in sectionList"
            :key="item.value"
            :value="item.value"
            :label="item.label"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="text-center">
      <el-button type="primary" size="small" @click="save" :loading="saveLoading">保存</el-button>
      <el-button size="small" @click="handleClose">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { DataCategoryApi } from '@wiz-api/data-category-management'

const dataCategoryApi = new DataCategoryApi()
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      saveLoading: false,
      formData: {
        leftMaxNum: '',
        rightMaxNum: '',
        defaultSection: '',
      },
      sectionList: [
        {
          value: 1,
          label: '左1',
        },
        {
          value: 2,
          label: '左2',
        },
        {
          value: 3,
          label: '左3',
        },
        {
          value: 4,
          label: '左4',
        },
        {
          value: 5,
          label: '总览',
        },
        {
          value: 6,
          label: '右1',
        },
        {
          value: 7,
          label: '右2',
        },
        {
          value: 8,
          label: '右3',
        },
        {
          value: 9,
          label: '右4',
        },
      ],
      formRules: {
        leftMaxNum: { required: true, message: '请输入左侧面板最大共存数', trigger: 'blur' },
        rightMaxNum: { required: true, message: '请输入右侧面板最大共存数', trigger: 'blur' },
        defaultSection: { required: true, message: '请选择默认开启板块', trigger: 'blur' },
      },
      dictionaryList: [],
      cateId: '',
    }
  },
  methods: {
    // 关闭弹框
    handleClose() {
      this.$emit('update:visible', false)
      this.$refs.formRef.resetFields()
      this.formData = this.$options.data().formData
    },
    async handleOpen() {
      await this.getDataDictionary()
    },
    // 获取数据字典数据
    async getDataDictionary() {
      const [err, res] = await dataCategoryApi.getByCode({
        code: 'CloudRenderManagement',
      })
      if (!err && res) {
        this.dictionaryList = res.dataItems
        this.cateId = res.id
        _.forEach(this.dictionaryList, (item) => {
          if (item.code in this.formData) {
            this.formData[item.code] = Number(item.data)
          }
        })
      }
    },
    // 保存
    save() {
      this.$refs.formRef.validate(async (valid) => {
        this.saveLoading = true
        if (valid) {
          const paramsList = []
          _.forEach(this.dictionaryList, async (item) => {
            if (item.code in this.formData) {
              paramsList.push({
                ..._.pick(item, ['code', 'displayName', 'id', 'remark', 'seqNo']),
                data: this.formData[item.code] + '',
              })
            }
          })
          const [err, res] = await dataCategoryApi.updateDataItems(this.cateId, {
            body: paramsList,
          })
          if (!err) {
            this.$message({
              showClose: true,
              message: '保存成功',
              type: 'success',
            })
            this.$emit('update:visible', false)
          }
        }
        this.saveLoading = false
      })
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  .el-input-number {
    width: 280px;
  }
}
</style>
